import api from '../api'
import { CommunityEndpoints } from './constants'
import { GetMigrationCommunitiesProps } from './types'
import { CommunityToMigrateProps } from './types'

class CommunityService {
  static async getMigrationCommunities({
    rows,
    communityId,
    nextPageToken,
    membership,
    type
  }: GetMigrationCommunitiesProps) {
    const communityIdParam = communityId ? `&communityId=${communityId}` : ''
    const nextPageTokenParam = nextPageToken ? `&nextPageToken=${nextPageToken}` : ''
    const membershipParam = membership ? `&slug=${membership}` : ''
    const typeParam = type ? `&type=${type}` : ''
    const url = `${CommunityEndpoints.getMigrationCommunities()}?rows=${rows}${communityIdParam}${nextPageTokenParam}${membershipParam}${typeParam}`

    const res = await api.get(url)

    return res.data
  }

  static async getMemberships(rows, nextPageToken) {
    const nextPageTokenParam = nextPageToken ? `&nextPageToken=${nextPageToken}` : ''
    const url = `${CommunityEndpoints.getMemberships()}?rows=${rows}${nextPageTokenParam}`

    const res = await api.get(url)

    return res.data
  }

  static async putMigrationCommunities(
    membershipSlug: string,
    communities: CommunityToMigrateProps[]
  ) {
    const url = CommunityEndpoints.putMigrationCommunities(membershipSlug)

    const res = await api.put(url, { communities })

    return res.data
  }

  static async putFollowPublicCommunity(communityId) {
    const url = CommunityEndpoints.putFollowPublicCommunity(communityId)

    const rest = await api.put(url)

    return rest.data
  }

  static async putUnfollowPublicCommunity(communityId) {
    const url = CommunityEndpoints.putUnfollowPublicCommunity(communityId)

    const rest = await api.put(url)

    return rest.data
  }
}

export default CommunityService
